function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M132.084 0.136826C175.618 2.62353 215.499 73.6919 225.211 109.895C234.923 146.098 241.285 181.118 217.62 202.143C193.955 223.169 150.278 224.918 103.572 220.819C56.8662 216.738 12.5836 199.211 2.26582 170.022C-8.05194 140.833 18.874 90.8416 42.5389 61.0697C66.2038 31.2978 87.1245 -2.41848 132.084 0.136826Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 90.8135,
  y1: 177.5,
  x2: 218.293,
  y2: 213.923,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6C4092"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A522E1"
})));

var SvgYampiPurple = function SvgYampiPurple(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 223,
    viewBox: "0 0 234 223",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYampiPurple, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yampi-purple.c2108c1c.svg";
export { ForwardRef as ReactComponent };